import dot from '../../Images/icons/dot.svg';
import python from '../../Images/icons/python.svg';
import vscode from '../../Images/icons/vscode.svg';
import react from '../../Images/icons/react.svg';
import js from '../../Images/icons/js.svg';
import html from '../../Images/icons/html.svg';
import google from '../../Images/icons/google.svg';
import linux from '../../Images/icons/linux.svg'
import DataScience from '../../Images/icons/DataScience.png'
import Bootstrap from '../../Images/icons/bootstrap.svg'

const languages = [
    
    {
      icon: react,
      name: "ReactJS",
      level: 65,
    },
    {
      icon: js,
      name: "Javascript",
      level: 55,
    },
    
    {
      icon: html,
      name: "Html & Css",
      level: 80,
    },
    {
      icon: Bootstrap,
      name: "Bootstrap",
      level: 50,
    },
    {
      icon: DataScience,
      name: "ML",
      level: 30,
    },
    {
      icon: python,
      name: "Python",
      level: 30,
    },
  ];
  
  const Tools = [
      
    {
      icon: vscode,
      name: "VS Code",
      level: 80,
    },
    {
      icon: dot,
      name: "Jupyter Notebook",
      level: 90,
    },
    {
      icon: google,
      name: "Google Colab",
      level: 60,
    },
    {
      icon: linux,
      name: "Linux",
      level: 75,
    }
  ];
    
export {languages, Tools};